<div class="nav_container" *ngIf="logged == 'true' && profil == 1">
  <!--  Side Bar Pour Profil Maimouna Eleve -->

  <!--  Side Bar Pour Apprenant FCC -->
  <div>
    <!-- Outils ELEVES  -->

    <ul>
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          AMBASSADEUR STEM
        </li>
        <li>
          <a
            [routerLink]="['stemd/add-eleve']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  id="Icon"
                  d="M12 8V16M8 12H16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="#E5E8EC"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">Ajouter un élève</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['stemd/stemd-apprenants-stemd']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  id="Icon"
                  d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
                  stroke="#E5E8EC"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
            <span class="flex-1 ms-3 whitespace-nowrap">Liste des élèves</span>
          </a>
        </li>
      </div>
    </ul>
    <!-- FIN ELEVES -->
    <ul>
      <div class="mb-4">
        <!-- Outils -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Outils
        </li>
        <li
          *ngIf="
            isAmi ||
            coursera_user ||
            cohorte == parcours3 ||
            cohorte == parcours4 ||
            cohorte ||
            hasMae ||
            isBenin
          "
        >
          <a
            [routerLink]="['agenda/apprenant']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                fill="#E5E8EC"
                stroke="black"
                stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
              />
            </svg>
            <span class="ml-3">Mon SIGUI</span>
          </a>
        </li>

        <li>
          <a
            [routerLink]="['users/portfolio']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 19"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z"
              />
            </svg>
            <span class="ml-3">Mon portfolio</span>
          </a>
        </li>
      </div>
      <div class="mb-4" *ngIf="isInCohort">
        <ul>
          <li class="uppercase text-greyLighter text-sm font-bold mb-2">
            Mentorat
          </li>
          <li>
            <a
              [routerLink]="['mentorat/groupeapprenant']"
              class="nav_item"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <svg
                style="margin-left: -5px; width: 24px; height: 24px"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <!-- Icône de groupe de personnes -->
                <path
                  fill="currentColor"
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                />
              </svg>
              <span class="ml-3">Groupe</span>
            </a>
          </li>
          <li>
            <a
              [routerLink]="['mentorat/mescours']"
              class="nav_item"
              routerLinkActive="active-link"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  fill="#E5E8EC"
                  stroke="black"
                  stroke-width="6"
                  d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
                />
              </svg>
              <span class="ml-3">Mon emploi du temps</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="mb-4" *ngIf="coursera_user || isOffTrackStudent || cohorte">
        <!-- PLATEFORME LMS -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Plateforme LMS
        </li>
        <div
          *ngIf="
            !coursera_user ||
            cohorte == parcours3 ||
            cohorte == parcours4 ||
            cohorte
          "
        >
          <li>
            <button
              (click)="toggleCollapse(1)"
              class="toggle-button bg-transparent"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  fill="#E5E8EC"
                  stroke="black"
                  stroke-width="6"
                  d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
                />
              </svg>
              SIGUI
              <i
                [class.pi]="true"
                [class.pi-chevron-down]="sections[0].isCollapsed"
                [class.pi-chevron-up]="!sections[0].isCollapsed"
                style="margin-left: auto"
              ></i>
            </button>
            <div
              [@slideToggle]="sections[0].isCollapsed ? 'closed' : 'open'"
              class="animated-paragraph"
              style="margin-left: 8px"
            >
              <ul>
                <li>
                  <a
                    [routerLink]="['lms/hometestqualification']"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm"
                      >Liste tests de qualification</span
                    >
                  </a>
                </li>
                <li>
                  <a
                    style="padding-left: 12px"
                    [routerLink]="['lms/homechoicecertify']"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm">Mon choix de certificat</span>
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['lms/certificateFollow']"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm">Suivre mes certificats</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </div>

        <!---------------- DEBUT----- Partie Hors Parcours  ------------------- -->
        <div *ngIf="isOffTrackStudent && !hidden">
          <button
            (click)="toggleCollapse(3)"
            class="toggle-button bg-transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 552.7 512"
            >
              <defs>
                <style>
                  .cls-1 {
                    fill: none;
                    stroke: #fff;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 30px;
                  }

                  .cls-2 {
                    fill: #e5e8ec;
                    stroke: #000;
                    stroke-width: 6px;
                  }
                </style>
              </defs>
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <path
                    class="cls-2"
                    d="M400,401.6v46.4c0,8.8-7.2,16-16,16H64c-8.8,0-16-7.2-16-16V192h352v53.6c16,.3,32,.5,48,.6v-118.2c0-35.3-28.7-64-64-64h-40V24c0-13.3-10.7-24-24-24s-24,10.7-24,24v40h-144V24c0-13.3-10.7-24-24-24s-24,10.7-24,24v40h-40C28.7,64,0,92.7,0,128v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-45.8c-16,0-32-.3-48-.6Z"
                  />
                  <g id="arrow-right">
                    <line
                      class="cls-1"
                      x1="535"
                      y1="324.1"
                      x2="255.1"
                      y2="320.1"
                    />
                    <line
                      class="cls-1"
                      x1="535"
                      y1="324.1"
                      x2="478"
                      y2="395.3"
                    />
                    <line class="cls-1" x1="535" y1="324.1" x2="478" y2="253" />
                  </g>
                </g>
              </g>
            </svg>
            Hors SIGUI
            <i
              [class.pi]="true"
              [class.pi-chevron-down]="sections[2].isCollapsed"
              [class.pi-chevron-up]="!sections[2].isCollapsed"
              style="margin-left: auto"
            ></i>
          </button>
          <div
            [@slideToggle]="sections[2].isCollapsed ? 'closed' : 'open'"
            class="animated-paragraph"
            style="margin-left: 8px"
          >
            <ul>
              <li>
                <a
                  [routerLink]="['lms/hors-sigui']"
                  class="nav_item"
                  routerLinkActive="active-link"
                >
                  <i class="pi pi-chevron-right text-sm ms-2"></i>
                  <span class="ms-2 text-sm">Suivre mes certificats</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!----------------- Fin------- Partie Hors Parcours  -------------------------->

        <div
          *ngIf="
            !(
              cohorte == 'SIG2408-FODE' ||
              cohorte == 'SIG2402-FODE' ||
              cohorte == null
            ) && !hidden
          "
        >
          <!-- MON PPP -->
          <li>
            <button
              (click)="toggleCollapse(2)"
              class="toggle-button bg-transparent"
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                mirror-in-rtl="true"
                style="margin-left: 1px"
              >
                <path
                  fill="#E5E8EC"
                  d="M8 6H5c-.553 0-1-.448-1-1s.447-1 1-1h3c.553 0 1 .448 1 1s-.447 1-1 1zM13 10H5c-.553 0-1-.448-1-1s.447-1 1-1h8c.553 0 1 .448 1 1s-.447 1-1 1zM13 14H5c-.553 0-1-.448-1-1s.447-1 1-1h8c.553 0 1 .448 1 1s-.447 1-1 1z"
                />
                <path
                  fill="#E5E8EC"
                  d="M18 2v8c0 .55-.45 1-1 1s-1-.45-1-1V2.5c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5v19c0 .28.22.5.5.5h13c.28 0 .5-.22.5-.5V21c0-.55.45-1 1-1s1 .45 1 1v1c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h14c1.1 0 2 .9 2 2z"
                />
                <path
                  fill="#E5E8EC"
                  d="M23.87 11.882c.31.54.045 1.273-.595 1.643l-9.65 5.57c-.084.05-.176.086-.265.11l-2.656.66c-.37.092-.72-.035-.88-.314-.162-.278-.09-.65.17-.913l1.907-1.958c.063-.072.137-.123.214-.167.004-.01.012-.015.012-.015l9.65-5.57c.64-.37 1.408-.234 1.72.305l.374.65z"
                />
              </svg>
              Mon PPP
              <i
                [class.pi]="true"
                [class.pi-chevron-down]="sections[1].isCollapsed"
                [class.pi-chevron-up]="!sections[1].isCollapsed"
                style="margin-left: auto"
              ></i>
            </button>
            <div
              [@slideToggle]="sections[1].isCollapsed ? 'closed' : 'open'"
              class="animated-paragraph"
              style="margin-left: 8px"
            >
              <ul>
                <li>
                  <a
                    [href]="urlPpp"
                    target="_blank"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm">Connexion </span>
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['ppp/mon-bilan-de-competence']"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm">Mon bilan de compétence</span>
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['ppp/exploration-du-marche']"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm">Exploration du marché</span>
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['ppp/decision-realisation']"
                    class="nav_item"
                    routerLinkActive="active-link"
                  >
                    <i class="pi pi-chevron-right text-sm ms-2"></i>
                    <span class="ms-2 text-sm">Décisions et réalisation</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </div>
        <li *ngIf="isSigCohorte">
          <a
            routerLink="softskills/maliste"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              height="32"
              id="icon"
              viewBox="0 0 32 32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs></defs>
              <path d="M30,30H22V4h8Zm-6-2h4V6H24Z" fill="#E5E8EC" />
              <path d="M20,30H12V12h8Z" fill="#E5E8EC" />
              <path d="M10,30H2V18h8Z" fill="#E5E8EC" />
              <rect
                style="fill: none; color: #e5e8ec"
                data-name="&lt;Transparent Rectangle&gt;"
                height="32"
                id="_Transparent_Rectangle_"
                width="32"
              />
            </svg>
            <span class="ml-3">Soft Skills</span>
          </a>
        </li>

        <!---------------------------->
        <!----- PROFIL MOUSTAPHA ----->
        <!---------------------------->
        <div
          *ngIf="
            ((cohorte == parcours3 || cohorte == parcours4) &&
              coursera_user &&
              !hidden) ||
            coursera_user
          "
        >
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(urlProgramme)"
              >
                <svg
                  height="24"
                  id="svg8"
                  version="1.1"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <g
                    id="g1514"
                    style="display: inline"
                    transform="translate(-0.0011279,-290.64853)"
                  >
                    <path
                      fill="#E5E8EC"
                      d="m 2.31126,305.45171 a 1.0001,1.0001 0 0 0 -0.2928,0.71263 l 0.0345,5.48974 a 1.0001,1.0001 0 0 0 1.00697,0.99283 l 5.42206,-0.0359 a 1.0001,1.0001 0 0 0 0.70019,-0.2914 l 11.76119,-11.76119 c 1.38704,-1.387 1.38747,-3.6622 0,-5.04918 l -1.81887,-1.81886 c -1.38708,-1.387 -3.66487,-1.387 -5.05195,-1e-5 z m 1.70976,1.11866 8.09168,-8.09168 4.04099,4.04102 -8.09442,8.09442 -4.01202,0.0262 z m 9.50588,-9.50588 1.95975,-1.95975 c 0.62801,-0.628 1.59549,-0.62798 2.2235,1e-5 l 1.81887,1.81887 c 0.62805,0.62798 0.62768,1.59273 10e-6,2.22075 l -1.96112,1.96112 z"
                    />
                  </g>
                </svg>
                <span>Coursera</span>
              </button>
            </li>
            <!-- <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(urlScholarVox)"
              >
                <svg
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  style="transform: scale(1.1)"
                >
                  <path
                    fill="#E5E8EC"
                    d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                  />
                </svg>
                <span>Scholar Vox</span>
              </button>
            </li> -->
          </ul>
        </div>
        <!-- <ul>
          <li>
            <button class="nav_item text-left" (click)="openUrl(urlScholarVox)">
              <svg
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                style="transform: scale(1.1)"
              >
                <path
                  fill="#E5E8EC"
                  d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                />
              </svg>
              <span>Scholar Vox</span>
            </button>
          </li>
        </ul> -->
        <!-- Vacance Numerique -->
        <div *ngIf="isVCN && !hidden">
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(vcnRoute.VCN)"
              >
                <svg
                  height="24"
                  id="svg8"
                  version="1.1"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <g
                    id="g1514"
                    style="display: inline"
                    transform="translate(-0.0011279,-290.64853)"
                  >
                    <path
                      fill="#E5E8EC"
                      d="m 2.31126,305.45171 a 1.0001,1.0001 0 0 0 -0.2928,0.71263 l 0.0345,5.48974 a 1.0001,1.0001 0 0 0 1.00697,0.99283 l 5.42206,-0.0359 a 1.0001,1.0001 0 0 0 0.70019,-0.2914 l 11.76119,-11.76119 c 1.38704,-1.387 1.38747,-3.6622 0,-5.04918 l -1.81887,-1.81886 c -1.38708,-1.387 -3.66487,-1.387 -5.05195,-1e-5 z m 1.70976,1.11866 8.09168,-8.09168 4.04099,4.04102 -8.09442,8.09442 -4.01202,0.0262 z m 9.50588,-9.50588 1.95975,-1.95975 c 0.62801,-0.628 1.59549,-0.62798 2.2235,1e-5 l 1.81887,1.81887 c 0.62805,0.62798 0.62768,1.59273 10e-6,2.22075 l -1.96112,1.96112 z"
                    />
                  </g>
                </svg>
                <span>Vacances Citoyennes Numériques</span>
              </button>
            </li>
          </ul>
        </div>

        <!-- FOND D'AMORCAGE -->
        <!-- <div *ngIf="hasMae">
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(urlFondAmorcage)"
              >
                <svg
                  height="24"
                  width="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse cx="12" cy="7" rx="7" ry="3" fill="#E5E8EC" />
                  <path
                    fill="#E5E8EC"
                    d="M12 10c-3.87 0-7-1.34-7-3v3c0 1.66 3.13 3 7 3s7-1.34 7-3V7c0 1.66-3.13 3-7 3z"
                  />
                  <path
                    fill="#E5E8EC"
                    d="M12 14c-3.87 0-7-1.34-7-3v3c0 1.66 3.13 3 7 3s7-1.34 7-3v-3c0 1.66-3.13 3-7 3z"
                  />
                  <path
                    fill="#E5E8EC"
                    d="M12 18c-3.87 0-7-1.34-7-3v3c0 1.66 3.13 3 7 3s7-1.34 7-3v-3c0 1.66-3.13 3-7 3z"
                  />
                </svg>
                <span>Fond d'amorçage</span>
              </button>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- AMI -->
      <div *ngIf="isAmi" class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">AMI</li>
        <li>
          <a
            [routerLink]="['ami/activiteami']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 24 22.7"
            >
              <defs>
                <style>
                  .cls-1 {
                    fill: #e5e7eb;
                  }
                </style>
              </defs>
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <g>
                    <path
                      class=""
                      style="fill: #e5e7eb"
                      d="M17.8,4.3v-1.3c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.2H7.8v-1.2c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.3c-2.3.4-4,2.3-4,4.7v8c0,2.6,2.1,4.8,4.8,4.8h10c2.6,0,4.8-2.1,4.8-4.8h0v-8c0-2.3-1.7-4.3-4-4.7ZM7,5.8h10c1.5,0,2.8,1,3.1,2.5H3.8c.3-1.5,1.6-2.5,3.2-2.5ZM17,20.3H7c-1.8,0-3.2-1.5-3.2-3.2v-7.2h16.5v7.2c0,1.8-1.5,3.2-3.2,3.2Z"
                    />
                    <path
                      class=""
                      style="fill: #e5e7eb"
                      d="M14.5,12.5l-3.5,3.5-1.5-1.5c-.3-.3-.8-.3-1.1,0-.3.3-.3.7,0,1l2,2c.3.3.8.3,1.1,0l4-4c.3-.3.3-.8,0-1.1-.3-.3-.7-.3-1,0Z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span class="ml-3">Activités mensuelles</span>
          </a>
        </li>
        <!-- <li>
          <a
            [routerLink]="['ami/convention']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 110 109.9"
              style="width: 22px; height: 22px"
            >
              <g>
                <g id="Calque_1">
                  <path fill="#F3F4F6"
                    d="M34.2,10.1c.6-.6,1.3-.9,2.1-.9h47.5c5.6,0,10.2,4.6,10.2,10.2v73.2c0,5.6-4.6,10.2-10.2,10.2H26.2c-5.6,0-10.2-4.6-10.2-10.2V29.5l.5-1.6,17.7-17.8ZM37.1,51.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM45,85.1h19.9c3.9,0,3.9-6,0-6h-19.9c-3.9,0-3.9,6,0,6ZM37.1,68.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM22,32.5v60.1c0,2.3,1.9,4.2,4.2,4.2h57.6c2.3,0,4.2-1.9,4.2-4.2V19.4c0-2.3-1.9-4.2-4.2-4.2h-44.5v14.3c0,1.7-1.3,3-3,3h-14.3ZM33.3,26.5v-7l-7,7h7Z" />
                </g>
              </g>
            </svg>
            <span class="ml-3">Mes conventions</span>
          </a>
        </li> -->
        <li>
          <a
            [routerLink]="['ami/listecharte']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 110 109.9"
              style="width: 22px; height: 22px"
            >
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <path
                    fill="#F3F4F6"
                    d="M34.2,10.1c.6-.6,1.3-.9,2.1-.9h47.5c5.6,0,10.2,4.6,10.2,10.2v73.2c0,5.6-4.6,10.2-10.2,10.2H26.2c-5.6,0-10.2-4.6-10.2-10.2V29.5l.5-1.6,17.7-17.8ZM37.1,51.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM45,85.1h19.9c3.9,0,3.9-6,0-6h-19.9c-3.9,0-3.9,6,0,6ZM37.1,68.1h35.8c3.9,0,3.9-6,0-6h-35.8c-3.9,0-3.9,6,0,6ZM22,32.5v60.1c0,2.3,1.9,4.2,4.2,4.2h57.6c2.3,0,4.2-1.9,4.2-4.2V19.4c0-2.3-1.9-4.2-4.2-4.2h-44.5v14.3c0,1.7-1.3,3-3,3h-14.3ZM33.3,26.5v-7l-7,7h7Z"
                  />
                </g>
              </g>
            </svg>
            <span class="ml-3">Mes chartes</span>
          </a>
        </li>

        <!-- END AMI -->
      </div>
      <!-- Scholar Vox -->

      <!-- <div
        *ngIf="
          isAmi &&
          !cohorte &&
          !isOffTrackStudent &&
          !coursera_user &&
          !hidden &&
          cohorte != parcours3 &&
          cohorte != parcours4
        "
        class="mb-4"
      >
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Plateforme LMS
        </li>
        <div>
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(urlScholarVox)"
              >
                <svg
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  style="transform: scale(1.1)"
                >
                  <path
                    fill="#E5E8EC"
                    d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                  />
                </svg>
                <span>Scholar Vox</span>
              </button>
            </li>
          </ul>
        </div>
      </div> -->

      <!-------------------------->
      <!-- FIN PROFIL COURSERA -->
      <!-------------------------->
      <div class="mb-4" *ngIf="hasMae">
        <!-- Fond d'Amorcage -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Accompagnement
        </li>
        <li>
          <a
            style="cursor: pointer"
            (click)="showIframe = true"
            class="nav_item"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                fill="#E5E8EC"
                stroke="black"
                stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
              />
            </svg>
            <span class="ml-3">Connexion</span>
          </a>
        </li>

        <li>
          <a [href]="urlClasseVirtuelle" target="_blank" class="nav_item">
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 19"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z"
              />
            </svg>
            <span class="ml-3">Classe Virtuelle</span>
          </a>
        </li>
        <!-- END SOFT SKILLS PARCOURS3 -->
      </div>
    </ul>
  </div>

  <!--  Compte -->
  <div>
    <ul>
      <div class="mb-4">
        <div>
          <li class="uppercase text-greyLighter text-sm font-bold mb-1">
            Compte
          </li>
          <li>
            <a
              [routerLink]="['users/profil']"
              class="nav_item"
              routerLinkActive="active-link"
            >
              <svg
                class="text-greyLighter"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 18"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z"
                />
              </svg>
              <span class="ml-3">Mon Profil</span>
            </a>
          </li>
          <!-- <li>
            <a [routerLink]="['consentement']" class="nav_item" routerLinkActive="active-link">
              <svg class="text-greyLighter" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 14 18">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z" />
              </svg>
              <span class="ml-3">Consentement</span>
            </a>
          </li> -->
        </div>
      </div>
    </ul>
  </div>
</div>

<app-iframe-modal
  *ngIf="showIframe"
  [iframeUrl]="urlFondAmorcage"
  (closed)="showIframe = false"
/>
